// NATIVE 
import * as React from 'react';


// INSTALLED 
import { Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';



// CUSTOM 
import { useDispatch } from 'react-redux';
import { SnackAlert } from '../../SnackAlert';
import { timeToClosedToast } from '../../../commons';
import MultipleSnackbars from '../../MultipleSnackbars';
import { storeCreateCargo } from '../../../store/cargos';
import { closeSessionGlobal } from '../../../commons/utils';
import { CreateCargo } from '../../cargos/crear/CreateCargo';
import validationSchema from '../../cargos/formModels/crear/validationSchema';
import formInitialValues from '../../cargos/formModels/crear/formInitialValues';
import createCargoFormModel from '../../cargos/formModels/crear/createCargoFormModel';
import { ModalSessionExpired } from '../../generics/ModalSessionExpired';




const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));




/**
 * CreateDialogCargo component is a modal dialog used for creating a new cargo.
 * It utilizes Formik for form handling and validation, and Redux for state management.
 * 
 * @param {object} props - The properties object.
 * @param {boolean} props.open - Determines if the dialog is open.
 * @param {function} props.handleCloseDialogCrearCargo - Function to handle closing the dialog.
 * @param {boolean} [props.buttons=false] - Optional property to show buttons.
 * 
 * @returns {JSX.Element} The rendered CreateDialogCargo component.
 * 
 * @example
 * <CreateDialogCargo 
 *   open={isOpen} 
 *   handleCloseDialogCrearCargo={handleClose} 
 *   buttons={true} 
 * />
 */
export const CreateDialogCargo = (props:any) =>  {


  // USE DISPATCH 
  const dispatch = useDispatch();


  // PROPS 
  const{ open, handleCloseDialogCrearCargo, buttons = false } = props;


  // DATA MODELS 
  const { formId, formField } = createCargoFormModel;
  const currentValidationSchema = validationSchema[0];

  


  // USE STATE 
  const [alert_snack, setAlertSnack] = React.useState(false);
  const [percentaje_area, setPercentajeArea] = React.useState(0);
  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<string[]>([]); 
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [isSubmiting, setIsSubmiting] = React.useState<boolean>(false);

  const [txtBtnEditCargo, setTxtBtnEditCargo] = React.useState<string>('Crear Area');
  
  const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
  });
    

  //  USE EFFECT 
  React.useEffect(() => {
      setIsSubmiting(!open);
  }, [props]);

  
  // CONST FUNCTIONS 
  const handleCloseC = () => {
    handleCloseDialogCrearCargo(false);
  };


  const _handleSubmit = async(values:any, actions:any) => {


    setTxtBtnEditCargo('Un Monento...')
    actions.setSubmitting(true);
    setIsSubmiting(true);

    const response = await dispatch( storeCreateCargo(values, setPercentajeArea) );


    const result = validateResponse(response, ' (Crear Cargo )');

    await setTxtBtnEditCargo('Crear Cargo');

    if ( response.code == 409) {
        setIsSubmiting(false);
    }

    if (!result) {
      return false;
    }

    setIsSubmiting(false);

    if (response.ok) {

      const errors:any = {
        msg: 'Cargo Creado Con Exito',
        status: 'success'
      };
    
      await setMsgSnack(errors);
      await setAlertSnack(true);

      actions.resetForm();
      actions.setSubmitting(false);
      handleCloseDialogCrearCargo(false);

    }
    
    
    

  }



  const validateResponse = async(response:any, textActionConcat: string) => {
    
    
        if (  response.code == 401  ) {
          await localStorage.removeItem('lastSelectedQypht');
          await closeSessionGlobal();
          await handleCloseDialogCrearCargo(false);
          setModalSessionExpired(true);
          return false;
        }

      
        // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
        if (!response.ok && response.code == 403 ) { 

            const errors:any = {
              msg: response.errors[0]+' '+textActionConcat,
              status: 'error'
            };
            
            await setMsgSnack(errors);
            await setAlertSnack(true);

            return false;
        }




        // 403 EL DATO YA SE ENCUENTRA REGISTRADO
        if (!response.ok && response.code == 409 ) { 
    
            const errors:any = {
                msg: response.errors+' '+textActionConcat,
                status: 'error'
            };
            
            await setMsgSnack(errors);
            await setAlertSnack(true);

            return false;
        }

        
        // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
        if (!response.ok && response.code == 400 ) { 

          const errors:any = [];

          response.errors.forEach( (element:any) => {
              
              errors.push({
                type: 'error',
                text: element
              })
          });

            
          setMessagesAlerts(errors);
          return false;

        }

        return true;
      
  }

  return (
    <React.Fragment>

      <ModalSessionExpired  open={modalSessionExpired}  />
      <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />

      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>
      
      <BootstrapDialog
        onClose={handleCloseC}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
           Crear Cargo
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseC}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        
   
        <Grid  >
            <Formik 
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}>

              <>
              <Form id={formId}>
                <CreateCargo formField={formField}/>

                <Button
                    disabled={isSubmiting}
                    style={{ marginTop: 10, float: 'right' }}
                    type="submit"
                    variant="contained"
                    color={ "primary"}
                  >
                    {
                      txtBtnEditCargo
                    }
                </Button>
                </Form>
              </>

            </Formik>
        </Grid>
       
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}